import { render, staticRenderFns } from "./ListUserMerchant.vue?vue&type=template&id=01146d4c"
import script from "./ListUserMerchant.vue?vue&type=script&lang=js"
export * from "./ListUserMerchant.vue?vue&type=script&lang=js"
import style0 from "./ListUserMerchant.vue?vue&type=style&index=0&id=01146d4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports